var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4411_31037",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4411_31037)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7997 40.8061C50.0783 31.5276 50.0783 16.4841 40.7997 7.20561C31.5212 -2.07292 16.4778 -2.07292 7.19924 7.20561C-2.07928 16.4841 -2.07928 31.5276 7.19924 40.8061C16.4778 50.0846 31.5212 50.0846 40.7997 40.8061Z",
    fill: "url(#paint0_linear_4411_31037)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9197 39.926C48.7121 31.1336 48.7121 16.8782 39.9197 8.08568C31.1272 -0.706796 16.8718 -0.706797 8.0793 8.08568C-0.713173 16.8782 -0.713173 31.1336 8.0793 39.926C16.8718 48.7185 31.1272 48.7185 39.9197 39.926Z",
    fill: "url(#paint1_linear_4411_31037)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.2682 43.6313C11.0918 41.8899 4.10069 33.8441 4.02824 24.1578C3.94618 13.1455 12.8387 4.11973 23.851 4.03767C29.1858 3.99819 34.2164 6.03797 38.0165 9.7821C41.8166 13.5262 43.9316 18.5259 43.9714 23.8604C44.0109 29.1949 41.9711 34.2255 38.227 38.026C34.4829 41.826 29.4835 43.9407 24.1487 43.9805C22.8227 43.9905 21.5249 43.8699 20.2682 43.6317V43.6313ZM27.5759 5.37842C26.3636 5.14838 25.1203 5.03542 23.8582 5.04469C18.7929 5.08246 14.0452 7.09031 10.4899 10.6992C6.93462 14.3077 4.99749 19.0849 5.03526 24.1502C5.07303 29.2158 7.08122 33.9632 10.6897 37.5185C14.2986 41.0734 19.0748 43.0106 24.1411 42.9728C29.2064 42.935 33.9541 40.9272 37.5094 37.3183C41.0644 33.7098 43.0018 28.9329 42.9637 23.8673C42.9259 18.802 40.9181 14.0543 37.3092 10.499C34.5996 7.82952 31.2304 6.07196 27.5756 5.37807L27.5759 5.37842Z",
    fill: "url(#paint2_linear_4411_31037)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.08 18.2284C16.08 17.675 16.5298 17.2266 17.0846 17.2266H22.9111C23.466 17.2266 23.9157 17.6753 23.9157 18.2284V34.261C23.9157 34.8145 23.466 35.2629 22.9111 35.2629H17.0846C16.5298 35.2629 16.08 34.8142 16.08 34.261V18.2284Z",
    fill: "#E1BE32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7885 15.3677C24.7885 14.5932 25.4182 13.9648 26.1948 13.9648H34.5424C35.7946 13.9648 36.4226 15.4742 35.5381 16.3583L27.1898 24.7062C26.3043 25.5917 24.7878 24.9662 24.7878 23.7154V15.3674L24.7885 15.3677Z",
    fill: "#E1BE32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.529 35.6166C26.9742 35.6166 26.5244 35.1679 26.5244 34.6147V29.0684C26.5244 28.1812 27.5956 27.7318 28.2315 28.3519L33.9176 33.8982C34.5613 34.5262 34.1157 35.6166 33.2151 35.6166H27.529Z",
    fill: "#E1BE32"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7005 11.4336C7.60215 14.7114 5.70239 19.134 5.70239 24.0004C5.70239 34.1058 13.8944 42.2978 23.9998 42.2978C30.8342 42.2978 36.7935 38.5508 39.9353 32.9989C26.3533 32.5829 14.9046 23.6907 10.7005 11.4336Z",
    fill: "url(#paint3_linear_4411_31037)",
    fillOpacity: 0.3
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.08 17.0722C16.08 16.5187 16.5298 16.0703 17.0846 16.0703H22.9111C23.466 16.0703 23.9157 16.5191 23.9157 17.0722V33.1048C23.9157 33.6583 23.466 34.1067 22.9111 34.1067H17.0846C16.5298 34.1067 16.08 33.6579 16.08 33.1048V17.0722Z",
    fill: "#A85D14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7885 14.2115C24.7885 13.4369 25.4182 12.8086 26.1948 12.8086H34.5424C35.7946 12.8086 36.4226 14.3179 35.5381 15.202L27.1898 23.55C26.3043 24.4355 24.7878 23.8099 24.7878 22.5591V14.2111L24.7885 14.2115Z",
    fill: "#A85D14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.529 34.4604C26.9742 34.4604 26.5244 34.0116 26.5244 33.4585V27.9122C26.5244 27.025 27.5956 26.5755 28.2315 27.1956L33.9176 32.7419C34.5613 33.3699 34.1157 34.4604 33.2151 34.4604H27.529Z",
    fill: "#A85D14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4411_31037",
    x1: -6.2791,
    y1: 3.42663,
    x2: 65.1422,
    y2: 51.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C68A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B47C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AA731E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AF781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DEA731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0D257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FDF173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7E267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4411_31037",
    x1: 8.0078,
    y1: 40.2381,
    x2: 44.2882,
    y2: 3.40939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.220876,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543048,
    stopColor: "#F0D257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7E267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4411_31037",
    x1: 4.37507,
    y1: 20.2811,
    x2: 43.6243,
    y2: 27.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C68A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B47C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AA731E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AF781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DEA731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F0D257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FAED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FDF173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7E267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E2A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4411_31037",
    x1: 32.7383,
    y1: 17.446,
    x2: 13.3484,
    y2: 37.1085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2B4",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoinsIcon);
export default __webpack_public_path__ + "static/media/koins-icon.f02b961e2667f02e9358af0947740212.svg";
export { ForwardRef as ReactComponent };